import {BaseEntity} from '../common/base-entity';

export class AcceptTermsConditionsDto extends BaseEntity{
    userId : number;
    termsAcceptedDate: Date;
}
